import { useEffect } from 'react'
import { ToggleComponent } from '../../../_metronic/assets/ts/components'

const ATRIBUTO = 'data-kt-aside-minimize'

/**
 * Recolhe ou expande o menu lateral pelo mesmo `ToggleComponent` do botão do header, para o botão
 * continuar em sincronia; sem ele (layout sem o botão), mexe direto no atributo do body.
 */
const recolherAside = (recolher: boolean) => {
  const botao = document.getElementById('kt_aside_toggle')
  const toggle = botao ? (ToggleComponent.getInstance(botao) as ToggleComponent | null) : null
  if (toggle) {
    if (recolher) toggle.enable()
    else toggle.disable()
  } else if (recolher) {
    document.body.setAttribute(ATRIBUTO, 'on')
  } else {
    document.body.removeAttribute(ATRIBUTO)
  }
}

/**
 * Tela que precisa da largura toda: o menu lateral começa recolhido e, ao sair, volta como estava
 * (se o usuário já o tinha recolhido, continua recolhido).
 */
export const useAsideRecolhido = () => {
  useEffect(() => {
    const jaRecolhido = document.body.getAttribute(ATRIBUTO) === 'on'
    if (!jaRecolhido) recolherAside(true)
    return () => {
      if (!jaRecolhido) recolherAside(false)
    }
  }, [])
}
